// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file checkout/fe/v1/checkout_fe_api.proto (package checkout.fe.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Struct } from "../../../google/protobuf/struct_pb";
import { BillingAddressCollectionFields, CardNetwork, CheckoutOptions, EncryptedCard, EncryptedElectronicCheck, EncryptedPayByBank, EncryptedSepa, EncryptedStoredPaymentMethod, EncryptedWallet, Klarna, Lpm, OrderOrigination, PartialAuthInfo, PaymentGatewayType, PaymentMethodSettings } from "../../../common/v1/common_pb";
import { IntegrationType, Layout, Mandate, OrdersOnHpp, PageHeader, PaymentButtonName, PaymentMethods, SecuritySettings, TaxIntegration, WalletPaymentMethod } from "../../../common/v1/merchant_settings_pb";
import { BrowserInfo, ScaChallengeWindowSize } from "../../../common/v1/three_domain_secure_pb";
import { PayRequestErrorCode } from "../../../common/v1/payment_errors_pb";
import { Timestamp } from "../../../google/protobuf/timestamp_pb";
import { PartialAuthPaymentMethod, PaymentProfile, PayRequestResult } from "../../../payment/v1/payment_pb";
import { PaymentMethodTypeCode } from "../../../common/v1/payment_pb";
import { Cart } from "../../../merchant/v1/cart_pb";
import { ShopperProfile } from "../../../common/v1/shopper_pb";
import { Event } from "../../../event/v1/event_pb";

/**
 * SessionType to indicate which product the jwt should be created for
 *
 * @generated from enum checkout.fe.v1.SessionType
 */
export const SessionType = proto3.makeEnum(
  "checkout.fe.v1.SessionType",
  [
    {no: 0, name: "SESSION_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SESSION_TYPE_CHECKOUT_SETTINGS", localName: "CHECKOUT_SETTINGS"},
    {no: 2, name: "SESSION_TYPE_MPP_PAYMENT_LINKS", localName: "MPP_PAYMENT_LINKS"},
  ],
);

/**
 * @generated from message checkout.fe.v1.GetMerchantSettingsRequest
 */
export const GetMerchantSettingsRequest = proto3.makeMessageType(
  "checkout.fe.v1.GetMerchantSettingsRequest",
  [],
);

/**
 * @generated from message checkout.fe.v1.GetMerchantSettingsResponse
 */
export const GetMerchantSettingsResponse = proto3.makeMessageType(
  "checkout.fe.v1.GetMerchantSettingsResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: GetMerchantSettingsResponse_MerchantSettings },
  ],
);

/**
 * @generated from message checkout.fe.v1.GetMerchantSettingsResponse.MerchantSettings
 */
export const GetMerchantSettingsResponse_MerchantSettings = proto3.makeMessageType(
  "checkout.fe.v1.GetMerchantSettingsResponse.MerchantSettings",
  () => [
    { no: 1, name: "custom_theme", kind: "message", T: Struct },
    { no: 2, name: "form_config", kind: "message", T: Struct },
    { no: 3, name: "encryption_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "encryption_key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "payment_settings", kind: "message", T: PaymentMethodSettings, repeated: true },
    { no: 6, name: "safetech_merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "billing_address_collection_fields", kind: "enum", T: proto3.getEnumType(BillingAddressCollectionFields) },
    { no: 8, name: "payment_methods", kind: "message", T: PaymentMethods },
    { no: 10, name: "supported_ship_to_country_region", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "merchant_display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "integration_type", kind: "enum", T: proto3.getEnumType(IntegrationType) },
    { no: 13, name: "layout", kind: "enum", T: proto3.getEnumType(Layout) },
    { no: 14, name: "orders_on_hpp", kind: "message", T: OrdersOnHpp },
    { no: 15, name: "address_autocomplete_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "payment_button_name", kind: "enum", T: proto3.getEnumType(PaymentButtonName) },
    { no: 18, name: "order_mandates", kind: "message", T: Mandate, repeated: true },
    { no: 19, name: "security_settings", kind: "message", T: SecuritySettings },
    { no: 20, name: "page_header", kind: "message", T: PageHeader },
    { no: 21, name: "supported_payment_gateway_type", kind: "enum", T: proto3.getEnumType(PaymentGatewayType) },
    { no: 22, name: "brand_experience", kind: "message", T: Struct },
    { no: 23, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "billing_address_country_restriction", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 25, name: "tax_integration", kind: "message", T: TaxIntegration },
    { no: 26, name: "surcharge_fee_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
  {localName: "GetMerchantSettingsResponse_MerchantSettings"},
);

/**
 * @generated from message checkout.fe.v1.GetEncryptionKeyRequest
 */
export const GetEncryptionKeyRequest = proto3.makeMessageType(
  "checkout.fe.v1.GetEncryptionKeyRequest",
  [],
);

/**
 * @generated from message checkout.fe.v1.GetEncryptionKeyResponse
 */
export const GetEncryptionKeyResponse = proto3.makeMessageType(
  "checkout.fe.v1.GetEncryptionKeyResponse",
  () => [
    { no: 1, name: "encryption_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "encryption_key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message checkout.fe.v1.GetHostedFieldsSettingsRequest
 */
export const GetHostedFieldsSettingsRequest = proto3.makeMessageType(
  "checkout.fe.v1.GetHostedFieldsSettingsRequest",
  [],
);

/**
 * @generated from message checkout.fe.v1.GetHostedFieldsSettingsResponse
 */
export const GetHostedFieldsSettingsResponse = proto3.makeMessageType(
  "checkout.fe.v1.GetHostedFieldsSettingsResponse",
  () => [
    { no: 1, name: "safetech_merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "hosted_fields_payment_methods", kind: "message", T: HostedFieldsPaymentMethods, opt: true },
    { no: 3, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * Describes subset of Hosted Fields Supported Method of Payments.
 *
 * @generated from message checkout.fe.v1.HostedFieldsPaymentMethods
 */
export const HostedFieldsPaymentMethods = proto3.makeMessageType(
  "checkout.fe.v1.HostedFieldsPaymentMethods",
  () => [
    { no: 1, name: "wallet_payment_method", kind: "message", T: WalletPaymentMethod },
  ],
);

/**
 * PayRequest defines a request for Pay endpoint.
 *
 * @generated from message checkout.fe.v1.PayRequest
 */
export const PayRequest = proto3.makeMessageType(
  "checkout.fe.v1.PayRequest",
  () => [
    { no: 1, name: "payment_method", kind: "message", T: PaymentMethod },
    { no: 2, name: "accepted_mandates", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "browser_info", kind: "message", T: BrowserInfo },
    { no: 4, name: "sca_challenge_window_size", kind: "enum", T: proto3.getEnumType(ScaChallengeWindowSize) },
    { no: 5, name: "billing_address_from_intent_billing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "consent_to_store_for_future_payments", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "save_payment_method_to_profile", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "make_default_payment_method", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "order_digest", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "lpm_payment_cancelled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "device_fingerprint_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * PayResponse defines a response for Pay request.
 *
 * @generated from message checkout.fe.v1.PayResponse
 */
export const PayResponse = proto3.makeMessageType(
  "checkout.fe.v1.PayResponse",
  () => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(PayResponse_Status) },
    { no: 3, name: "debug_info", kind: "message", T: PayResponse_DebugInfo },
    { no: 4, name: "pay_request_error_code", kind: "enum", T: proto3.getEnumType(PayRequestErrorCode) },
    { no: 5, name: "sca_orchestration_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "lpm_orchestration_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "masked_pan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "card_type_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "card_expiration_month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "card_expiration_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "account_holder_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "approval_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "payment_gateway_transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "pbb_consent_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "nonce_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "nonce_token_expiration_timestamp", kind: "message", T: Timestamp },
    { no: 17, name: "payment_gateway_transaction_timestamp", kind: "message", T: Timestamp },
    { no: 18, name: "total_transaction_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 19, name: "partial_authorization", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 20, name: "klarna_payment_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "klarna_orchestration_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines possible outcomes of Pay request.
 *
 * @generated from enum checkout.fe.v1.PayResponse.Status
 */
export const PayResponse_Status = proto3.makeEnum(
  "checkout.fe.v1.PayResponse.Status",
  [
    {no: 0, name: "STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "STATUS_SUCCESS", localName: "SUCCESS"},
    {no: 2, name: "STATUS_TRANSIENT_FAILURE", localName: "TRANSIENT_FAILURE"},
    {no: 3, name: "STATUS_FAILURE", localName: "FAILURE"},
    {no: 4, name: "STATUS_PENDING", localName: "PENDING"},
  ],
);

/**
 * @generated from message checkout.fe.v1.PayResponse.DebugInfo
 */
export const PayResponse_DebugInfo = proto3.makeMessageType(
  "checkout.fe.v1.PayResponse.DebugInfo",
  () => [
    { no: 1, name: "pay_result", kind: "message", T: PayRequestResult },
  ],
  {localName: "PayResponse_DebugInfo"},
);

/**
 * Payment method.
 *
 * @generated from message checkout.fe.v1.PaymentMethod
 */
export const PaymentMethod = proto3.makeMessageType(
  "checkout.fe.v1.PaymentMethod",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(PaymentMethod_Type) },
    { no: 2, name: "card", kind: "message", T: EncryptedCard },
    { no: 3, name: "electronic_check", kind: "message", T: EncryptedElectronicCheck },
    { no: 4, name: "wallet", kind: "message", T: EncryptedWallet },
    { no: 5, name: "stored_payment_method", kind: "message", T: EncryptedStoredPaymentMethod },
    { no: 7, name: "sepa", kind: "message", T: EncryptedSepa },
    { no: 8, name: "lpm", kind: "message", T: Lpm },
    { no: 9, name: "pay_by_bank", kind: "message", T: EncryptedPayByBank },
    { no: 10, name: "klarna", kind: "message", T: Klarna },
  ],
);

/**
 * Defines supported payment method types.
 *
 * @generated from enum checkout.fe.v1.PaymentMethod.Type
 */
export const PaymentMethod_Type = proto3.makeEnum(
  "checkout.fe.v1.PaymentMethod.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_CARD", localName: "CARD"},
    {no: 2, name: "TYPE_ELECTRONIC_CHECK", localName: "ELECTRONIC_CHECK"},
    {no: 3, name: "TYPE_WALLET", localName: "WALLET"},
    {no: 4, name: "TYPE_STORED_PAYMENT_METHOD", localName: "STORED_PAYMENT_METHOD"},
    {no: 5, name: "TYPE_SEPA", localName: "SEPA"},
    {no: 6, name: "TYPE_LPM", localName: "LPM"},
    {no: 7, name: "TYPE_PAY_BY_BANK", localName: "PAY_BY_BANK"},
    {no: 8, name: "TYPE_GIFT_CARD", localName: "GIFT_CARD"},
    {no: 9, name: "TYPE_KLARNA", localName: "KLARNA"},
  ],
);

/**
 * Defines the request for an Apple Pay Payment session request.
 *
 * @generated from message checkout.fe.v1.RequestApplePayPaymentSessionRequest
 */
export const RequestApplePayPaymentSessionRequest = proto3.makeMessageType(
  "checkout.fe.v1.RequestApplePayPaymentSessionRequest",
  () => [
    { no: 1, name: "validation_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchant_domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Defines the response for an Apple Pay Payment session request.
 *
 * @generated from message checkout.fe.v1.RequestApplePayPaymentSessionResponse
 */
export const RequestApplePayPaymentSessionResponse = proto3.makeMessageType(
  "checkout.fe.v1.RequestApplePayPaymentSessionResponse",
  () => [
    { no: 1, name: "payment_session", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * GetCheckoutSessionRequest defines a request for the GetCheckoutSession endpoint.
 *
 * @generated from message checkout.fe.v1.GetCheckoutSessionRequest
 */
export const GetCheckoutSessionRequest = proto3.makeMessageType(
  "checkout.fe.v1.GetCheckoutSessionRequest",
  () => [
    { no: 1, name: "method_of_payment", kind: "enum", T: proto3.getEnumType(PaymentMethodTypeCode), opt: true },
  ],
);

/**
 * GetCheckoutSessionResponse defines a response for the GetCheckoutSession endpoint.
 *
 * @generated from message checkout.fe.v1.GetCheckoutSessionResponse
 */
export const GetCheckoutSessionResponse = proto3.makeMessageType(
  "checkout.fe.v1.GetCheckoutSessionResponse",
  () => [
    { no: 3, name: "checkout_options", kind: "message", T: CheckoutOptions },
    { no: 1, name: "cart", kind: "message", T: Cart },
    { no: 2, name: "shopper_profile", kind: "message", T: ShopperProfile },
    { no: 6, name: "payment_profile", kind: "message", T: PaymentProfile },
    { no: 5, name: "debug_info", kind: "message", T: GetCheckoutSessionResponse_DebugInfo },
    { no: 7, name: "order_origination", kind: "enum", T: proto3.getEnumType(OrderOrigination) },
    { no: 8, name: "reference", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "shopper_billing_address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "is_paid", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "surcharge_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 12, name: "total_transaction_amount_with_surcharge", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 14, name: "partial_auth_details", kind: "message", T: PartialAuthDetail, repeated: true },
    { no: 15, name: "is_pending", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message checkout.fe.v1.GetCheckoutSessionResponse.DebugInfo
 */
export const GetCheckoutSessionResponse_DebugInfo = proto3.makeMessageType(
  "checkout.fe.v1.GetCheckoutSessionResponse.DebugInfo",
  () => [
    { no: 1, name: "pay_result", kind: "message", T: PayRequestResult },
  ],
  {localName: "GetCheckoutSessionResponse_DebugInfo"},
);

/**
 * @generated from message checkout.fe.v1.PartialAuthDetail
 */
export const PartialAuthDetail = proto3.makeMessageType(
  "checkout.fe.v1.PartialAuthDetail",
  () => [
    { no: 6, name: "payment_method", kind: "message", T: PartialAuthPaymentMethod },
    { no: 7, name: "partial_auth_info", kind: "message", T: PartialAuthInfo },
  ],
);

/**
 * @generated from message checkout.fe.v1.CreateSettingsSessionRequest
 */
export const CreateSettingsSessionRequest = proto3.makeMessageType(
  "checkout.fe.v1.CreateSettingsSessionRequest",
  () => [
    { no: 1, name: "subject_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "session_type", kind: "enum", T: proto3.getEnumType(SessionType) },
  ],
);

/**
 * @generated from message checkout.fe.v1.CreateSettingsSessionResponse
 */
export const CreateSettingsSessionResponse = proto3.makeMessageType(
  "checkout.fe.v1.CreateSettingsSessionResponse",
  () => [
    { no: 1, name: "settings_session_jwt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message checkout.fe.v1.SendEventsRequest
 */
export const SendEventsRequest = proto3.makeMessageType(
  "checkout.fe.v1.SendEventsRequest",
  () => [
    { no: 1, name: "events", kind: "message", T: Event, repeated: true },
  ],
);

/**
 * @generated from message checkout.fe.v1.SendEventsResponse
 */
export const SendEventsResponse = proto3.makeMessageType(
  "checkout.fe.v1.SendEventsResponse",
  [],
);

/**
 * @generated from message checkout.fe.v1.UpdateCartRequest
 */
export const UpdateCartRequest = proto3.makeMessageType(
  "checkout.fe.v1.UpdateCartRequest",
  () => [
    { no: 1, name: "cart", kind: "message", T: Cart },
    { no: 2, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message checkout.fe.v1.UpdateCartResponse
 */
export const UpdateCartResponse = proto3.makeMessageType(
  "checkout.fe.v1.UpdateCartResponse",
  () => [
    { no: 1, name: "order_digest", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * DeletePaymentProfilePaymentMethodRequest defines a request to delete the payment method of the PaymentProfile.
 *
 * @generated from message checkout.fe.v1.DeletePaymentProfilePaymentMethodRequest
 */
export const DeletePaymentProfilePaymentMethodRequest = proto3.makeMessageType(
  "checkout.fe.v1.DeletePaymentProfilePaymentMethodRequest",
  () => [
    { no: 1, name: "payment_method_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message checkout.fe.v1.DeletePaymentProfilePaymentMethodResponse
 */
export const DeletePaymentProfilePaymentMethodResponse = proto3.makeMessageType(
  "checkout.fe.v1.DeletePaymentProfilePaymentMethodResponse",
  () => [
    { no: 1, name: "payment_profile", kind: "message", T: PaymentProfile },
  ],
);

/**
 * @generated from message checkout.fe.v1.PaymentMethodInfo
 */
export const PaymentMethodInfo = proto3.makeMessageType(
  "checkout.fe.v1.PaymentMethodInfo",
  () => [
    { no: 1, name: "payment_method", kind: "message", T: PaymentMethod },
    { no: 2, name: "is_nonce_generation", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message checkout.fe.v1.GetBinDataRequest
 */
export const GetBinDataRequest = proto3.makeMessageType(
  "checkout.fe.v1.GetBinDataRequest",
  () => [
    { no: 1, name: "encrypted_pan", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message checkout.fe.v1.GetBinDataResponse
 */
export const GetBinDataResponse = proto3.makeMessageType(
  "checkout.fe.v1.GetBinDataResponse",
  () => [
    { no: 1, name: "is_card_pinless_debit", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "card_networks", kind: "enum", T: proto3.getEnumType(CardNetwork), repeated: true },
  ],
);

/**
 * @generated from message checkout.fe.v1.UpdateDefaultPaymentProfilePaymentMethodRequest
 */
export const UpdateDefaultPaymentProfilePaymentMethodRequest = proto3.makeMessageType(
  "checkout.fe.v1.UpdateDefaultPaymentProfilePaymentMethodRequest",
  () => [
    { no: 1, name: "payment_method_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message checkout.fe.v1.UpdateDefaultPaymentProfilePaymentMethodResponse
 */
export const UpdateDefaultPaymentProfilePaymentMethodResponse = proto3.makeMessageType(
  "checkout.fe.v1.UpdateDefaultPaymentProfilePaymentMethodResponse",
  () => [
    { no: 1, name: "payment_profile", kind: "message", T: PaymentProfile },
  ],
);

